import React from 'react';
import PaginationRC from 'rc-pagination';
import NextPrevButton from './components/NextButton';
import { LOCALE_RU } from './const';

import './styles/pagination.module.scss';

const Pagination = ({ paginationProps }) => {
  if (paginationProps.total <= paginationProps.pageSize) return null;

  const totalPages = Math.ceil(
    paginationProps.total / paginationProps.pageSize,
  );
  const isLastPage = paginationProps.current >= totalPages;
  const isFirstPage = paginationProps.current === 1;

  const itemRender = (page, type, element) => {
    if (type === 'prev')
      return !isFirstPage ? <NextPrevButton side={'prev'} /> : null;
    if (type === 'next')
      return !isLastPage ? <NextPrevButton side={'next'} /> : null;
    return element;
  };

  return (
    <PaginationRC
      prefixCls="pagination"
      itemRender={itemRender}
      locale={LOCALE_RU}
      {...paginationProps}
    />
  );
};

export default Pagination;
